module.exports = __webpack_public_path__ + "static/media/greycross.58279cf1.svg";